// Lightweight analytics loader — supports Plausible OR Google Analytics 4.
// Set REACT_APP_PLAUSIBLE_DOMAIN (e.g. "preetibasu.com") to enable Plausible,
// or REACT_APP_GA_MEASUREMENT_ID (e.g. "G-XXXXXXXXXX") to enable GA4.
// Setting neither disables tracking silently (useful for local dev / preview).

const PLAUSIBLE_DOMAIN = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let provider = null; // "plausible" | "ga4" | null
let initialized = false;

const injectScript = (src, attrs = {}) => {
  const s = document.createElement("script");
  s.src = src;
  s.async = true;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
  return s;
};

export const initAnalytics = () => {
  if (initialized) return provider;
  initialized = true;

  if (PLAUSIBLE_DOMAIN) {
    provider = "plausible";
    injectScript("https://plausible.io/js/script.tagged-events.js", {
      "data-domain": PLAUSIBLE_DOMAIN,
      defer: "",
    });
    // Plausible queues events if called before script loads
    window.plausible =
      window.plausible ||
      function () {
        (window.plausible.q = window.plausible.q || []).push(arguments);
      };
    return provider;
  }

  if (GA_ID) {
    provider = "ga4";
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { anonymize_ip: true });
    return provider;
  }

  return null;
};

// Fire a custom event. `name` is the event label; `props` is a flat object.
export const trackEvent = (name, props = {}) => {
  if (!initialized) initAnalytics();
  if (provider === "plausible" && typeof window.plausible === "function") {
    window.plausible(name, { props });
  } else if (provider === "ga4" && typeof window.gtag === "function") {
    window.gtag("event", name, props);
  }
  // else: no-op (analytics disabled)
};
